// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 

/**
 * Provides helper methods for dealing with/checking for type exhaustion.
 * 
 * ```
 * type Field = "a" | "b";
 * 
 * let f: Field = ...;
 * if (f === "a" || f == "b")
 * {
 *   ...
 * }
 * else
 * {
 *   // f is exhausted and has the type never
 *   // we make sure that if Field is changed this condition holds:
 *   Assert.ensureNever(f); 
 * }
 * ```
 */
export class Assert
{
  static ensureNever(value: never): never
  {
    throw new Error("Never assertion failed.");
  }

  static isNever(value: never): void
  {
  }

  static never(): never
  {
    throw new Error("Never assertion failed.");
  }
}